import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import template from './exLabel.template.html';
import controller from './exLabel.controller';

export default angular.module('exLabel', [uiRouter])
	.component('exLabel', {
		bindings: {
			page: '@',
			key: '@'
		},
		template,
		controller
	})
	.name;



// WEBPACK FOOTER //
// ./src/app/components/common/exLabel/exLabel.js